import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const SearchFilter = ({
    loading = false,
    filters = {},
    restoreFilterValues,
}) => (
    <Field
        component={Form.ReduxInput}
        disabled={loading}
        name='search'
        placeholder='Search...'
        setValue={restoreFilterValues(filters, 'search') ?? ''}
    />
);

SearchFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object,
    restoreFilterValues: PropTypes.func.isRequired,
};
